import { useQuery } from '@tanstack/react-query';

export interface LiveTip {
  id: string;
  matchId: string;
  league: string;
  homeTeam: string;
  awayTeam: string;
  currentScore: { home: number; away: number } | string;
  minute: number;
  market: string;
  prediction: string;
  odds: string;
  confidence: number;
  reasoning: string;
  releasedAt: string;
  expiresAt: string;
  status: 'active' | 'won' | 'lost' | 'void' | 'expired';
  settledAt?: string | null;
  isPremium: boolean;
  createdAt: string;
}

export interface LiveTipsResponse {
  count: number;
  tips: LiveTip[];
}

async function fetchLiveTips(): Promise<LiveTipsResponse> {
  const response = await fetch('/api/tips/live');
  if (!response.ok) {
    throw new Error('Failed to fetch live tips');
  }
  return response.json();
}

export function useLiveTips() {
  return useQuery({
    queryKey: ['live-tips'],
    queryFn: fetchLiveTips,
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 25000, // Consider data stale after 25 seconds
  });
}
